<script setup lang="ts">
defineOptions({
  name: 'TabRedDot',
})
</script>

<template>
  <span class="tab-red-dot" aria-hidden="true"></span>
</template>

<style lang="scss" scoped>
.tab-red-dot {
  position: absolute;
  top: 10px;
  right: 4px;
  display: block;
  width: 20px;
  height: 20px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: #ff223f;
  box-sizing: border-box;
  pointer-events: none;
}
</style>
